import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from './DefaultModal';

function ReportMarginModal({ show, onClose, onSuccess, idEntidade }) {
  const [margins, setMargins] = useState({
    R: { marginTop: '2.0', marginBottom: '2.0', marginLeft: '2.0', marginRight: '2.0' },
    P: { marginTop: '2.0', marginBottom: '2.0', marginLeft: '2.0', marginRight: '2.0' },
  });
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (show && idEntidade) {
      setLoading(true);
      axios
        .get(`${API_BASE_URL.REPORT_MARGIN}/entidade/${idEntidade}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(res => {
          const updated = { ...margins };
          res.data.forEach(m => {
            updated[m.orientacao] = {
              marginTop: String(m.marginTop || '2.0'),
              marginBottom: String(m.marginBottom || '2.0'),
              marginLeft: String(m.marginLeft || '2.0'),
              marginRight: String(m.marginRight || '2.0'),
            };
          });
          setMargins(updated);
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, [show, idEntidade]);

  const handleChange = (orientacao, field, value) => {
    setMargins(prev => ({
      ...prev,
      [orientacao]: { ...prev[orientacao], [field]: value },
    }));
  };

  const handleSave = () => {
    const promises = ['R', 'P'].map(orientacao =>
      axios.post(
        `${API_BASE_URL.REPORT_MARGIN}/save`,
        {
          idEntidade,
          orientacao,
          marginTop: parseFloat(margins[orientacao].marginTop) || 0,
          marginBottom: parseFloat(margins[orientacao].marginBottom) || 0,
          marginLeft: parseFloat(margins[orientacao].marginLeft) || 0,
          marginRight: parseFloat(margins[orientacao].marginRight) || 0,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
    );

    Promise.all(promises)
      .then(() => {
        showDefaultModal('success', 'Margens salvas com sucesso!');
        setTimeout(() => {
          onSuccess?.();
          onClose();
        }, 1000);
      })
      .catch(err => {
        showDefaultModal('error', err.response?.data || 'Erro ao salvar margens!');
      });
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-md" style={{ maxWidth: '500px' }}>
        <div className="modal-content">
          <div
            className="modal-header text-white"
            style={{
              background: 'linear-gradient(45deg, rgb(30,27,75) 0%, rgb(55,48,163) 100%)',
              padding: '0.35rem 1rem',
              borderTopLeftRadius: '0.5rem',
              borderTopRightRadius: '0.5rem',
              border: 'none',
            }}
          >
            <h6 className="m-0">
              <i className="bi bi-rulers me-2"></i>Configurar Margens
            </h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body" style={{ fontSize: '0.85rem' }}>
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Carregando...</span>
                </div>
              </div>
            ) : (
              <>
                {['R', 'P'].map(orientacao => (
                  <div key={orientacao} className="mb-3">
                    <h6 className="fw-bold mb-2" style={{ color: '#3730A3' }}>
                      <i className={`bi ${orientacao === 'R' ? 'bi-phone' : 'bi-tablet-landscape'} me-1`}></i>
                      {orientacao === 'R' ? 'Retrato (A4)' : 'Paisagem (A4)'}
                    </h6>
                    <div className="row g-2">
                      {[
                        { field: 'marginTop', label: 'Topo', icon: 'bi-arrows-up' },
                        { field: 'marginBottom', label: 'Base', icon: 'bi-arrows-down' },
                        { field: 'marginLeft', label: 'Esquerda', icon: 'bi-arrows-left' },
                        { field: 'marginRight', label: 'Direita', icon: 'bi-arrows-right' },
                      ].map(({ field, label, icon }) => (
                        <div key={field} className="col-6">
                          <label className="form-label mb-0" style={{ fontSize: '0.75rem' }}>
                            <i className={`bi ${icon} me-1`}></i>{label} (cm)
                          </label>
                          <input
                            type="number"
                            className="form-control form-control-sm"
                            step="0.1"
                            min="0"
                            max="10"
                            value={margins[orientacao][field]}
                            onChange={e => handleChange(orientacao, field, e.target.value)}
                          />
                        </div>
                      ))}
                    </div>
                    <div className="mt-1" style={{ fontSize: '0.7rem', color: '#6B7280' }}>
                      <span>PX: Topo {Math.round(parseFloat(margins[orientacao].marginTop || 0) * 28.35)} | Base {Math.round(parseFloat(margins[orientacao].marginBottom || 0) * 28.35)} | Esq {Math.round(parseFloat(margins[orientacao].marginLeft || 0) * 28.35)} | Dir {Math.round(parseFloat(margins[orientacao].marginRight || 0) * 28.35)}</span>
                      {' | '}
                      <span>Twips: Topo {Math.round(parseFloat(margins[orientacao].marginTop || 0) * 567)} | Base {Math.round(parseFloat(margins[orientacao].marginBottom || 0) * 567)} | Esq {Math.round(parseFloat(margins[orientacao].marginLeft || 0) * 567)} | Dir {Math.round(parseFloat(margins[orientacao].marginRight || 0) * 567)}</span>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          <div
            className="modal-footer"
            style={{
              background: 'linear-gradient(45deg, rgb(30,27,75) 0%, rgb(55,48,163) 100%)',
              padding: '0.35rem 1rem',
              borderBottomLeftRadius: '0.5rem',
              borderBottomRightRadius: '0.5rem',
              border: 'none',
            }}
          >
            <button className="btn btn-sm btn-light" onClick={onClose}>
              <i className="bi bi-x-lg me-1"></i>Fechar
            </button>
            <button className="btn btn-sm btn-success" onClick={handleSave} disabled={loading}>
              <i className="bi bi-check-lg me-1"></i>Salvar
            </button>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </div>
  );
}

export default ReportMarginModal;
